import { render, staticRenderFns } from "./AssignmentManagement.vue?vue&type=template&id=7a085e44"
import script from "./AssignmentManagement.vue?vue&type=script&lang=js"
export * from "./AssignmentManagement.vue?vue&type=script&lang=js"
import style0 from "./AssignmentManagement.vue?vue&type=style&index=0&id=7a085e44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports